import axios from "../config/axiosConfig";

export const getAllCoins = async (
  page = 1,
  recordPerPage = 10,
  searchQuery = null,
  type = null,
  sortOrder = null,
  signal = null,
  withIntradayAvg = false
) => {
  try {
    const response = await axios.get("/coins", {
      params: {
        page,
        limit: recordPerPage,
        type: type,
        searchQuery: searchQuery,
        sortOrder: sortOrder,
        withIntradayAvg,
      },
      ...(signal ? { signal } : {}),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching coins:", error);
    throw error;
  }
};

export const getAllCoinsLite = async (
  page = 1,
  recordPerPage = 10,
  type = null,
  signal = null
) => {
  try {
    const response = await axios.get("/coins", {
      params: {
        page,
        limit: recordPerPage,
        type,
        lite: true,
      },
      ...(signal ? { signal } : {}),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching lite coins:", error);
    throw error;
  }
};

export const getAllDashboardTransaction = async () => {
  try {
    const response = await axios.get("/coins/dashboard-transaction");
    return response;
  } catch (error) {
    console.error("Error fetching coins:", error);
    throw error;
  }
};

// Lightweight: only id, name, symbol, logo — used for the marquee ticker on dashboard
export const getTickerCoins = async () => {
  try {
    const response = await axios.get("/coins/ticker");
    return response.data;
  } catch (error) {
    console.error("Error fetching ticker coins:", error);
    throw error;
  }
};

export const deleteCoin = async (id) => {
  try {
    const response = await axios.delete(`/coins/${id}`);
    return response.status;
  } catch (error) {
    throw error;
  }
};

export const updateCoin = async (data) => {
  try {
    const response = await axios.put(`/coins/${data?.id}`, data);
    console.log(response);
    return response?.status;
  } catch (error) {
    throw error;
  }
};

export const updateDashboardTransaction = async (data) => {
  try {
    const response = await axios.put(
      `/coins/dashboard-transaction/${data?.id}`,
      data
    );
    console.log(response);
    return response?.status;
  } catch (error) {
    throw error;
  }
};

export const createCoin = async (data) => {
  try {
    const response = await axios.post(`/coins`, data);
    return response?.status;
  } catch (error) {
    throw error;
  }
};

export const getCoinById = async (id) => {
  try {
    const response = await axios.get(`/coins/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCoinsForSelect = async () => {
  try {
    const response = await axios.get("/coins/users");
    return response.data;
  } catch (error) {
    console.error("Error fetching coins for select:", error);
    throw error;
  }
};
export const fetchIntraDayCoinsForSelect = async () => {
  try {
    const response = await axios.get("/intraday-trades/users");
    return response.data;
  } catch (error) {
    console.error("Error fetching coins for select:", error);
    throw error;
  }
};

export const updateCoinGeneralSettings = async (settings) => {
  const response = await axios.put("/coins/coin-general-settings", settings);
  return response.data;
};

export const getCoinGeneralSettings = async (signal = null) => {
  const response = await axios.get("/coins/coin-general-settings", {
    ...(signal ? { signal } : {}),
  });
  return response.data;
};

export const updateDashboardGeneralSettings = async (settings) => {
  const response = await axios.put(
    "/coins/dashboard-general-settings",
    settings
  );
  return response.data;
};

export const getDashboardGeneralSettings = async () => {
  const response = await axios.get("/coins/dashboard-general-settings");
  return response.data;
};

// Update (add/remove) a favorite coin
export const updateFavoriteCoin = async ({ coinId, type }) => {
  const response = await axios.put("/users/favorite-coins", {
    coinId,
    type, // should be either "add" or "remove"
  });
  return response.data;
};

// Get the user's favorite coin IDs
export const getFavoriteCoinIds = async (signal = null) => {
  const response = await axios.get("/users/favorites", {
    ...(signal ? { signal } : {}),
  });
  return response.data; // should return: [ 'btc-id', 'eth-id', ... ]
};
